'use es6';

import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import { getFullUrl } from 'hubspot-url-utils';
import noAuthApiClient from 'hub-http/clients/noAuthApiClient';
import QuickFetch from 'quick-fetch';
import Superstore, { IndexedDB } from 'superstore';
import * as api from 'laboratory-lib/core/api';
import * as client from 'laboratory-lib/client';
var defaultStore;

try {
  defaultStore = new Superstore({
    backend: IndexedDB,
    namespace: 'laboratory'
  });
} catch (err) {
  /* NOOP */
}

export function createClient() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var _ref$apiDomain = _ref.apiDomain,
      apiDomain = _ref$apiDomain === void 0 ? getFullUrl('api') : _ref$apiDomain,
      _ref$http = _ref.http,
      http = _ref$http === void 0 ? noAuthApiClient : _ref$http,
      _ref$onError = _ref.onError,
      onError = _ref$onError === void 0 ? api.reportError : _ref$onError,
      _ref$quickFetch = _ref.quickFetch,
      quickFetch = _ref$quickFetch === void 0 ? QuickFetch : _ref$quickFetch,
      _ref$store = _ref.store,
      store = _ref$store === void 0 ? defaultStore : _ref$store,
      _ref$timeout = _ref.timeout,
      timeout = _ref$timeout === void 0 ? 8000 : _ref$timeout,
      rest = _objectWithoutProperties(_ref, ["apiDomain", "http", "onError", "quickFetch", "store", "timeout"]);

  return client.createClient(Object.assign({
    apiDomain: apiDomain,
    http: http,
    onError: onError,
    quickFetch: quickFetch,
    store: store,
    timeout: timeout
  }, rest));
}